import { readUser } from '@directus/sdk';
import { redirect } from 'react-router';

import { PROMOTER_ROLE_ID } from '#constants/database-ids.ts';
import { ADMIN_SELECTED_USER_ID_KEY } from '#constants/localstorage-keys.ts';

import { readMeWithAdminAccess } from '../data/user/readMeWithAdminAccess.ts';
import { directusClient } from '../services/directusClient/directusClient.ts';

export const protectedLoader = async () => {
  try {
    const me = await readMeWithAdminAccess();

    if (!me) {
      return redirect('/auth/login');
    }

    const role = me.role as { id?: string; admin_access?: boolean } | null;

    // Admin user — check if they've selected a promoter to impersonate
    if (role?.admin_access === true) {
      const selectedUserId = localStorage.getItem(ADMIN_SELECTED_USER_ID_KEY);
      if (!selectedUserId) {
        return redirect('/log-in-as');
      }
      try {
        return await directusClient.request(readUser(selectedUserId));
      } catch {
        localStorage.removeItem(ADMIN_SELECTED_USER_ID_KEY);
        return redirect('/log-in-as');
      }
    }

    if (role?.id === PROMOTER_ROLE_ID) {
      return me;
    }

    return redirect('/wrong-role');
  } catch {
    return redirect('/auth/login');
  }
};
